import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tfa-eyebrow" }
const _hoisted_2 = { class: "tfa-page-title" }
const _hoisted_3 = { class: "tfa-page-sub" }
const _hoisted_4 = { class: "tfa-remote-body" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "tfa-grid-empty"
}
const _hoisted_7 = ["disabled", "aria-busy", "onClick"]
const _hoisted_8 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_9 = {
  key: 1,
  class: "bi bi-database-add"
}
const _hoisted_10 = { class: "tfa-remote-footer" }
const _hoisted_11 = ["disabled", "aria-busy"]
const _hoisted_12 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_13 = {
  key: 1,
  class: "bi bi-arrow-clockwise"
}
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "core",
    size: "xl",
    "dialog-style": "width: 90vw; max-width: 1400px",
    "prevent-close": _ctx.importingJobId !== null
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('components.tachoAnalysis.remoteFiles.eyebrow')), 1),
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('components.tachoAnalysis.remoteFiles.title')) + ": " + _toDisplayString(_ctx.driverName), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('components.tachoAnalysis.remoteFiles.sub')), 1)
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["tfa-remote-status", { 'is-error': !!_ctx.error }])
        }, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.error), 1)
              ], 64))
            : (_ctx.totalCount === null)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[2] || (_cache[2] = _createElementVNode("span", { class: "spinner-border spinner-border-sm" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachoAnalysis.remoteFiles.loading')), 1)
                ], 64))
              : (!_ctx.totalCount)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('components.tachoAnalysis.remoteFiles.empty')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(_ctx.filesSummary(_ctx.totalCount)), 1)
                  ], 64))
        ], 2),
        _createVNode(_component_DxDataGrid, {
          ref: "grid",
          class: "tfa-remote-grid",
          "column-auto-width": true,
          "data-source": _ctx.candidatesStore,
          "hover-state-enabled": true,
          "load-panel": { enabled: false },
          "no-data-text": _ctx.$t('components.tachoAnalysis.remoteFiles.empty'),
          "remote-operations": { paging: true, sorting: true, filtering: true },
          "row-alternation-enabled": true,
          "show-borders": false,
          "show-column-lines": false
        }, {
          "driver-cell": _withCtx(({ data }) => [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.driverName || _ctx.$t('components.tachoAnalysis.drivers.unknown')), 1),
              _createElementVNode("small", null, _toDisplayString(data.data.card_number || _ctx.$t('components.tachoAnalysis.remoteFiles.noCardNumber')), 1)
            ])
          ]),
          "file-cell": _withCtx(({ data }) => [
            _createElementVNode("div", null, [
              _createElementVNode("strong", null, _toDisplayString(data.data.filename || _ctx.$t('components.tachoAnalysis.remoteFiles.noFilename')), 1),
              _createElementVNode("small", null, [
                _createTextVNode(_toDisplayString(_ctx.formatBytes(data.data.file_size)), 1),
                (data.data.vehicle_registration)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" · " + _toDisplayString(data.data.vehicle_registration), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          "range-cell": _withCtx(({ data }) => [
            (data.data.activity_from && data.data.activity_to)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatDateFull(data.data.activity_from)) + " – " + _toDisplayString(_ctx.formatDateFull(data.data.activity_to)), 1),
                  _createElementVNode("small", null, _toDisplayString(data.data.days_count) + " " + _toDisplayString(_ctx.$t('components.tachoAnalysis.daysUnit')), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('components.tachoAnalysis.remoteFiles.rangeUnavailable')), 1))
          ]),
          "downloaded-cell": _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.data.job_completed_at ? _ctx.formatDateFull(data.data.job_completed_at, true) : '—'), 1)
          ]),
          "state-cell": _withCtx(({ data }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["tfa-pill", _ctx.statePillClass(data.data.state)])
            }, _toDisplayString(_ctx.$t('components.tachoAnalysis.remoteFiles.states.' + data.data.state)), 3)
          ]),
          "actions-cell": _withCtx(({ data }) => [
            (data.data.can_import)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "tfa-btn tfa-btn--primary tfa-btn--sm tfa-remote-import",
                  disabled: _ctx.importingJobId !== null,
                  "aria-busy": _ctx.importingJobId === data.data.job_id,
                  onClick: ($event: any) => (_ctx.importCandidate(data.data))
                }, [
                  (_ctx.importingJobId === data.data.job_id)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                    : (_openBlock(), _createElementBlock("i", _hoisted_9)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.importingJobId === data.data.job_id
                ? 'components.tachoAnalysis.remoteFiles.importing'
                : 'components.tachoAnalysis.remoteFiles.import')), 1)
                ], 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DxFilterRow, { visible: true }),
            _createVNode(_component_DxPaging, { "page-size": 10 }),
            _createVNode(_component_DxPager, {
              visible: (_ctx.totalCount ?? 0) > 10,
              "show-info": true,
              "show-navigation-buttons": true,
              "info-text": _ctx.$t('components.devexpress.pagerPage')
              + '{0}' + _ctx.$t('components.devexpress.pagerOf')
              + '{1}'
            }, null, 8, ["visible", "info-text"]),
            _createVNode(_component_DxColumn, {
              "allow-filtering": false,
              caption: _ctx.$t('components.tachoAnalysis.remoteFiles.cols.driver'),
              "min-width": 175,
              "data-field": "card_number",
              "cell-template": "driver-cell"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              caption: _ctx.$t('components.tachoAnalysis.remoteFiles.cols.file'),
              "min-width": 220,
              "data-field": "filename",
              "cell-template": "file-cell"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "allow-filtering": false,
              "allow-sorting": false,
              caption: _ctx.$t('components.tachoAnalysis.remoteFiles.cols.range'),
              "min-width": 195,
              "cell-template": "range-cell"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "allow-filtering": false,
              caption: _ctx.$t('components.tachoAnalysis.remoteFiles.cols.downloaded'),
              "min-width": 145,
              "data-field": "job_completed_at",
              "sort-order": "desc",
              "cell-template": "downloaded-cell"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "allow-filtering": false,
              "allow-sorting": false,
              caption: _ctx.$t('components.tachoAnalysis.remoteFiles.cols.state'),
              "css-class": "tfa-remote-state-cell",
              width: 285,
              "cell-template": "state-cell"
            }, null, 8, ["caption"]),
            _createVNode(_component_DxColumn, {
              "allow-filtering": false,
              "allow-sorting": false,
              caption: _ctx.$t('components.tachoAnalysis.remoteFiles.cols.actions'),
              "css-class": "tfa-remote-actions-cell",
              width: 135,
              "cell-template": "actions-cell"
            }, null, 8, ["caption"])
          ]),
          _: 1
        }, 8, ["data-source", "no-data-text"])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          type: "button",
          class: "tfa-btn",
          disabled: _ctx.importingJobId !== null || _ctx.refreshing,
          "aria-busy": _ctx.refreshing,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshGrid()))
        }, [
          (_ctx.refreshing)
            ? (_openBlock(), _createElementBlock("span", _hoisted_12))
            : (_openBlock(), _createElementBlock("i", _hoisted_13)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.tachoAnalysis.remoteFiles.refresh')), 1)
        ], 8, _hoisted_11),
        _createElementVNode("button", {
          type: "button",
          class: "tfa-btn tfa-btn--primary",
          disabled: _ctx.importingJobId !== null,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, _toDisplayString(_ctx.$t('components.tachoAnalysis.remoteFiles.close')), 9, _hoisted_14)
      ])
    ]),
    _: 1
  }, 8, ["prevent-close"]))
}